import { Map } from 'immutable';

import * as t from '../../actions/friendProfileActionType';

const initialState = Map({
  friendScoringHistory: {
    totalWeek: 0,
    scoringHistory: {
      id: 0,
      dateBeginWeek: 'june 1',
      dateEndWeek: 'june 7',
      weekPoints: {
        m: 120,
        tu: 120,
        w: 120,
        th: 120,
        f: 120,
        sa: 120,
        su: 120,
      },
    },
  },
});

const reducer = function friendScoringHistoryReducer(
  state = initialState,
  action,
) {
  switch (action.type) {
    case t.SET_FRIEND_SCORING_HISTORY:
      return state.set('friendScoringHistory', action.friendScoringHistoryData);
    default:
      return state;
  }
};

export default reducer;
